import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'usb-detail-modal-flight-result',
  templateUrl: './detail-modal-flight-result.component.html',
  styleUrls: ['./detail-modal-flight-result.component.scss']
})
export class DetailModalFlightResultComponent implements OnInit {

  flightData: any; // Datos del vuelo que recibirá

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    console.log('Datos del vuelo recibidos:', this.flightData);
  }

  // Función para cerrar el modal
  closeModal(): void {
    this.bsModalRef.hide();
  }

  // Función para formatear duración
  formatDuration(minutes: number): string {
    if (!minutes) return '';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}h ${mins}m`;
  }

  // Obtener el primer segmento (origen)
  getFirstSegment(): any {
    return this.flightData?.itinerary[0]?.options[0]?.segments[0];
  }

  // Obtener el último segmento (destino final)
  getLastSegment(): any {
    const segments = this.flightData?.itinerary[0]?.options[0]?.segments;
    return segments ? segments[segments.length - 1] : null;
  }

  // Obtener todos los segmentos
  getAllSegments(): any[] {
    return this.flightData?.itinerary[0]?.options[0]?.segments || [];
  }

  // Formatear fecha
  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('es-ES', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  // Agregar esta función en el componente del modal
  calculateLayover(index: number): number {
    const segments = this.getAllSegments();
    if (index >= segments.length - 1) return 0;

    const currentSegment = segments[index];
    const nextSegment = segments[index + 1];

    if (!currentSegment?.arrival?.dateTime || !nextSegment?.departure?.dateTime) return 0;

    const arrival = new Date(currentSegment.arrival.dateTime).getTime();
    const departure = new Date(nextSegment.departure.dateTime).getTime();

    return Math.floor((departure - arrival) / (1000 * 60)); // minutos
  }

}
